import React from "react";

const formatDate = (date, format) => {
  if (format === "YYYY") {
    return date.getFullYear();
  }
  return null;
};

const processDate = ({ node }) => {
  const format = node.attribs["data-date-format"];
  const date = new Date();

  const dateString = formatDate(date, format);
  return dateString && <span>{dateString}</span>;
};

const dateProcessor = () => ({ processDate });
export default dateProcessor;
